// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2196":"ee8b1517","4885":"75fc9c18"}[chunkId] || chunkId) + "." + {"2196":"6ca39abec88934f9","4885":"59b43d00c924b886","9352":"e5fe269cc1d9dc8f","9984":"76bdaec976e1d5e6"}[chunkId] + ".js";
};